// removed by extract-text-webpack-plugin
module.exports = {"sign-in-page":"sign-in-page","forgot-password":"forgot-password","sign-in-diagnostics":"sign-in-diagnostics","sign-in-diagnostics-loader":"sign-in-diagnostics-loader","visible":"visible","pulse-indicator":"pulse-indicator"};


//////////////////
// WEBPACK FOOTER
// ./src/application/scene/identity/scene/sign-in/sign-in.style.sass
// module id = 3p9A
// module chunks = 0